import { FC } from 'react';
import { css } from '@emotion/react';
import clsx from 'clsx';

import libraryVars from '@/library/assets/scss/abstracts/_exports.module.scss';

type CancelButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

const CancelButton: FC<CancelButtonProps> = ({ onClick, disabled }) => {
  return (
    <button
      type="button"
      disabled={disabled}
      className={clsx(
        'border-0 bg-transparent fs-14 fw-medium px-1',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
      )}
      css={css`
        color: ${libraryVars.violet};
      `}
      onClick={onClick}
    >
      Cancel
    </button>
  );
};

export default CancelButton;
